export default __webpack_public_path__ + "static/media/Aflac.dbfaba1f.svg";